import { useCallback, useState } from 'react';
import { Select, Typography, Flex, Spin } from 'antd';
import { debounce } from 'lodash';
import { useSelector } from 'react-redux';
import { getUsers } from '../../redux/actions/users';
import { getFullName } from '../../utils';
import { LoadingOutlined } from '@ant-design/icons';

const { Option } = Select;

const UserSearchSelect = ({
    value,
    onChange,
    size = 'large',
    placeholder = 'Search Assign User',
    showUnassigned = true,
}) => {
    const { users } = useSelector((state) => state.usersSlice);
    const [loading, setLoading] = useState(false);
    const [isSearched, setIsSearched] = useState(false);

    const handleUserSearch = useCallback(
        debounce(async (searchValue) => {
            setIsSearched(!!searchValue);
            setLoading(true);
            await getUsers({ searchText: searchValue, loading: false });
            setLoading(false);
        }, 300),
        []
    );

    return (
        <Select
            placeholder={placeholder}
            optionLabelProp="label"
            style={{ width: '100%' }}
            size={size}
            showSearch
            allowClear
            value={value}
            onChange={(val) => {
                onChange?.(val);
            }}
            filterOption={(input, option) =>
                String(option['data-name'] || '')
                    .toLowerCase()
                    .includes(input.toLowerCase()) ||
                String(option['data-email'] || '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
            }
            onDropdownVisibleChange={(open) => {
                if (open && !users?.length) getUsers({ loading: false });
            }}
            onSearch={handleUserSearch}
            onClear={() => getUsers({ loading: false })}
            notFoundContent={
                loading ? (
                    <Flex justify="center" align="center" gap={10}>
                        <Typography.Text type="secondary">Loading...</Typography.Text>
                        <Spin indicator={<LoadingOutlined spin />} size="small" />
                    </Flex>
                ) : isSearched ? (
                    <Flex justify="center" align="center" gap={10}>
                        <Typography.Text type="secondary">No Results</Typography.Text>
                    </Flex>
                ) : null
            }
        >
            {showUnassigned && (
                <Option key="unassigned" value="unassigned" label="Unassigned">
                    <Typography.Text strong type="secondary">
                        Unassigned
                    </Typography.Text>
                </Option>
            )}

            {isSearched &&
                users?.map((user) => (
                    <Option
                        key={user?.id}
                        value={user?.id}
                        label={getFullName(user)}
                        data-email={user?.email}
                        data-name={getFullName(user)}
                    >
                        <Flex vertical gap={1}>
                            <Typography.Text>{getFullName(user)}</Typography.Text>
                            <Typography.Text type="secondary">{user.email}</Typography.Text>
                        </Flex>
                    </Option>
                ))}
        </Select>
    );
};

export default UserSearchSelect;
